<template>
  <page :manualInit="$store.state.user.profile.init" :manualErr="$store.state.user.profile.initErr">
    <v-layout row wrap>
      <v-flex lg3 md4 xs12 class="pa-2">
        <v-navigation-drawer permanent light width="100%" height="400px" class="mavSmallMenu">
          <v-toolbar flat class="transparent">
            <v-list class="pa-0">
              <v-list-tile avatar>
                <v-list-tile-avatar>
                  <v-avatar :size="40" class="primary">
                    <span class="white--text">
                      {{$store.getters.userInitials}}
                    </span>
                  </v-avatar>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{$store.state.token.firstName}}, {{$store.state.token.lastName}}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-toolbar>
          <v-list class="pt-0">
            <v-divider></v-divider>
            <v-list-tile v-for="item in sideMenu" :key="item.name" :to="{ name: item.name }">
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-navigation-drawer>
      </v-flex>
      <v-flex lg9 md8 xs12 class="pa-2">
        <transition name="slide-x-transition" mode="out-in">
          <router-view ></router-view>
        </transition>
      </v-flex>
    </v-layout>
  </page>
</template>

<script>
import { mapActions } from 'vuex'
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays'
import toDate from 'date-fns/toDate'

export default {
  data() {
    return {
      sideMenu: [
        { name: 'profile', text: 'User Profile', icon: 'mdi-account' },
        { name: 'changePassword', text: 'Change Password', icon: 'mdi-lock' },
        { name: 'commsSettings', text: 'Communication Settings', icon: 'mdi-bell' }
      ],
      passwordExpiryDays: undefined
    }
  },
  computed: {
    passwordExpiryTitle() {
      return 'test'
    }
  },
  watch: {
    '$store.state.user.profile.init': function (value) {
      if (value === 1) {
        // Calculate password expiry days
        const passwordExpiryDate = this.$store.state.user.profile.passwordExpiryDate
        if (passwordExpiryDate) {
          const todayDate = new Date()
          const expiryDate = toDate(passwordExpiryDate)
          const diffDays = differenceInCalendarDays(expiryDate, todayDate)
          if (diffDays > 0) {
            this.passwordExpiryDays = diffDays
          } else {
            this.passwordExpiryDays = 0
          }
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'initProfile'
    ])
  },
  mounted() {
    this.initProfile()
  }
}
</script>

<style>

</style>
